import {MutationAdsConvertClickArgs, AdsClick, AdsOfferKind, Deal} from "@irati/types"
import PBService from "@irati/utils/services"
import client, {MutationOptions} from "@irati/utils/services/apollo"
import everflowTracker from "../utils/everflow"
import clickConvertMutation from "./mutations/clickConvert"
import adsClickQuery, {adsClickKey} from "./queries/adsClick"

class AdsService extends PBService {
  clickConvertForEverflow(tid: string, options: MutationOptions = {}) {
    const variables: MutationAdsConvertClickArgs = {
      data: {
        everflow: {
          tid
        }
      }
    }
    return client.mutate({...options, mutation: clickConvertMutation, variables})
  }

  click(deal: Deal, kind: AdsOfferKind) {
    const offer = deal?.offers?.find((t) => t.kind === kind)
    if (offer && offer.url) {
      client.query({query: adsClickQuery, variables: {offerId: offer.uuid}}).then(({data}) => {
        const {tid} = data[adsClickKey] as AdsClick
        if (deal.uuid && tid) {
          everflowTracker.setTid(deal.uuid, tid)
        }
      })
    }
  }
}

const adsService = new AdsService({errorHandlers: []})

export default adsService
